<template>
	<div class="invoice-creator" :aria-label="title">
		<header v-if="showTitle || $slots.status" class="creator-header">
			<div class="header-left">
				<h1 v-if="showTitle" class="creator-title">{{ title }}</h1>
			</div>
			<div class="status-slot">
				<slot name="status" />
			</div>
		</header>

		<section class="creator-section">
			<slot name="details" />
		</section>

		<section class="creator-section">
			<slot name="items" />
		</section>

		<footer v-if="$slots.footer" class="creator-footer">
			<slot name="footer" />
		</footer>
	</div>
</template>

<script setup>
defineEmits(['back']);

defineProps({
	showTitle: {
		type: Boolean,
		default: true,
	},
	title: {
		type: String,
		default: 'New client invoice',
	},
});
</script>

<style scoped>
.invoice-creator {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 24px;
	color: var(--text-color);
}

.creator-header {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	align-items: center;
	flex-wrap: wrap;
	min-height: 40px;
}

.header-left {
	display: flex;
	align-items: center;
	gap: 24px;
	flex-wrap: wrap;
}

.creator-title {
	display: flex;
	align-items: baseline;
	gap: 6px;
	flex-wrap: wrap;
	margin: 0;
	font-family: 'Fraunces', Georgia, serif;
	font-size: 1.5rem;
	font-weight: 600;
	color: var(--text-color);
}

.status-slot {
	display: flex;
	align-items: center;
	gap: 12px;
}

.creator-section {
	/* Removed card style to match legacy transparent background for sections */
	background: transparent;
	border: none;
	border-radius: 0;
	padding: 0;
	box-shadow: none;
}

.creator-footer {
	display: flex;
	gap: 16px;
	justify-content: flex-start;
	margin-top: 24px;
}

/* Align footer buttons like legacy */
.creator-footer button {
	min-height: 40px;
}
</style>
